<template>
    <div>
        <draggable :list="sections" draggable=".draggable" class="flex flex-wrap items-center -m-3" @change="sectionsReordered" :disabled="estimate.cannot_be_edited_by_authed_user">
            <div v-for="section in sections" :key="section.key" class="m-3 draggable">
                <div v-if="isActive(section)" class="flex">
                    <div class="relative">
                        <div
                            v-if="estimate.cannot_be_edited_by_authed_user"
                            class="relative flex items-center box-content m-0 border-0 shadow-none px-3 pl-2 py-2 font-medium text-sm rounded-l-md bg-blue-100 text-blue-700"
                            :class="section.optional ? 'pr-20' : 'pr-2'"
                            v-text="section.title"
                        ></div>
                        <autoresizable-input v-else measure="font-medium text-sm">
                            <input
                                ref="input"
                                type="text"
                                v-model="section.title"
                                @input="$store.save()"
                                class="relative inline-block box-content m-0 border-0 shadow-none px-3 pl-2 font-medium text-sm rounded-l-md bg-blue-100 text-blue-700 focus:z-20 focus:outline-none focus:ring-2 focus:ring-blue-600"
                                :class="section.optional ? 'pr-20' : 'pr-2'"
                            >
                        </autoresizable-input>
                        <div
                            v-if="section.optional"
                            @click="estimate.cannot_be_edited_by_authed_user ? null : $refs.input[0].focus()"
                            class="absolute z-20 right-0 inset-y-0 flex items-center justify-center w-20 italic font-semibold text-xs text-blue-700 tracking-wider"
                        >optional</div>
                    </div>
                    <ui-dropdown menu-class="p-3 w-48" class="flex" trigger-class="flex">
                        <template #default="{ toggle }">
                            <button @click="toggle" class="p-2 font-medium text-xs rounded-r-md bg-blue-100 text-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-600">
                                <i class="fa fa-chevron-down fa-fw"></i>
                            </button>
                        </template>

                        <template #menu="{ close }">
                            <ui-dropdown-item v-if="! estimate.cannot_be_edited_by_authed_user" icon="fas fa-adjust" @click="toggleOptional(section, close)">
                                {{ section.optional ? 'Remove optional' : 'Make optional' }}
                            </ui-dropdown-item>
                            <ui-dropdown-item icon="fas fa-clipboard-list" @click="$modals.open('estimates-old-page-material-list-sidepage', { context: section, contextType: 'section' }); close();">See material list</ui-dropdown-item>
                            <ui-dropdown-item v-if="! estimate.cannot_be_edited_by_authed_user" icon="fas fa-copy" @click="$store.duplicateSection(section); close();">Duplicate</ui-dropdown-item>
                            <ui-dropdown-item v-if="! estimate.cannot_be_edited_by_authed_user" icon="fas fa-trash" danger @click="deleteSection(section)">Delete</ui-dropdown-item>
                        </template>
                    </ui-dropdown>
                </div>
                <button
                    v-else
                    class="flex items-baseline px-3 py-2 font-medium text-sm rounded-md text-gray-500 hover:text-gray-700"
                    @click="select(section)"
                >
                    <div v-text="section.title"></div>
                    <div
                        v-if="section.optional"
                        class="pl-3 italic font-semibold text-xs tracking-wider"
                    >optional</div>
                </button>
            </div>
            <div slot="header" class="m-3">
                <button
                    class="px-3 py-2 font-medium text-sm rounded-md"
                    :class="isPage('cover') ? 'bg-blue-100 text-blue-700' : 'text-gray-500 hover:text-gray-700'"
                    @click="selectPage('cover')"
                >Cover</button>
            </div>
            <div slot="footer" class="m-3" v-if="! estimate.cannot_be_edited_by_authed_user">
                <button class="group px-3 py-2 inline-flex items-center space-x-2 font-medium text-sm rounded-md text-gray-400 hover:text-gray-700" @click="add">
                    <i class="fa fa-plus text-sm text-gray-300 group-hover:text-gray-500"></i>
                    <div>New</div>
                </button>
            </div>
        </draggable>
    </div>
</template>

<script>
import draggable from 'vuedraggable'
import { estimateStore } from '@stores'

export default {
    components: {
        draggable
    },
    props: {
        activeSection: Object,
        activePage: String,
    },
    computed: {
        $store () {
            return estimateStore
        },
        estimate () {
            return estimateStore.state.estimate
        },
        sections () {
            return estimateStore.state.estimate.sections
        },
    },
    methods: {
        add () {
            const newSection = this.$store.addSection()
            this.select(newSection)
            this.$nextTick(() => {
                if (! this.$refs.input?.[0]) return
                this.$refs.input[0].focus()
                this.$refs.input[0].select()
            })
        },
        deleteSection (section) {
            this.$modals.confirmDelete({
                title: `Delete section "${section.title}"`,
                button: 'Yes, delete section',
                handle: () => {
                    this.$store.deleteSection(section)
                    this.selectPage('cover')
                }
            })
        },
        isActive (section) {
            return section === this.activeSection
        },
        select (section) {
            this.$emit('update:active-section', section)
        },
        isPage (page) {
            return this.activeSection === null
                && this.activePage === page
        },
        selectPage (page) {
            this.$emit('update:active-section', null)
            this.$emit('update:active-page', page)
        },
        sectionsReordered () {
            this.$store.repopulateNumbers()
            this.$store.save()
        },
        toggleOptional (section, close) {
            section.optional = ! section.optional
            this.$store.recalculateTotals(false)
            this.$store.save()
            close()
        },
    },
}
</script>
